__turbopack_context__.v({
  "--is-photo-voting": "question-ad-image-module-scss-module__YFolqW__--is-photo-voting",
  "__container": "question-ad-image-module-scss-module__YFolqW____container",
  "question-ad": "question-ad-image-module-scss-module__YFolqW__question-ad",
});
